export default __webpack_public_path__ + "static/media/about_icon4.adc06dd0.svg";